import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ProfileIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ProfileIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_412_551)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2791 17.7292C19.6586 16.2181 20.5 14.2073 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.2073 4.34136 16.2181 5.72087 17.7292C6.5613 15.3746 9.04914 13.75 12 13.75C14.9509 13.75 17.4387 15.3746 18.2791 17.7292ZM17.0264 18.8553C16.6755 16.8805 14.7295 15.25 12 15.25C9.27055 15.25 7.32453 16.8805 6.97355 18.8553C8.38137 19.8892 10.1194 20.5 12 20.5C13.8806 20.5 15.6186 19.8892 17.0264 18.8553ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 11.3333C13.0125 11.3333 13.8333 10.5125 13.8333 9.5C13.8333 8.48748 13.0125 7.66667 12 7.66667C10.9875 7.66667 10.1667 8.48748 10.1667 9.5C10.1667 10.5125 10.9875 11.3333 12 11.3333ZM12 12.8333C13.8409 12.8333 15.3333 11.3409 15.3333 9.5C15.3333 7.65905 13.8409 6.16667 12 6.16667C10.1591 6.16667 8.66667 7.65905 8.66667 9.5C8.66667 11.3409 10.1591 12.8333 12 12.8333Z"
          fill={isGradient ? `url(#${gradientId})` : fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_412_551">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProfileIcon;
